<div class="stacked-chart-report" *ngIf="!isLoading && results">
  <div class="stacked-chart-report__header">
    <span class="stacked-chart-report__header__title">{{ title }}</span>
  </div>

  <div class="stacked-chart-report__body">
    <ngx-charts-bar-vertical-stacked
      *ngIf="results.length"
      [scheme]="schemePieColor"
      [results]="results"
      [xAxis]="showXAxis"
      [yAxis]="showYAxis"
      [legend]="showLegend"
    >
    </ngx-charts-bar-vertical-stacked>

    <p class="stacked-chart-report__no-results" *ngIf="!results.length">--</p>
  </div>
</div>

<!-- SKELETON-LOADER -->

<div class="stacked-chart-report" *ngIf="isLoading">
  <div class="stacked-chart-report__header">
    <ngx-skeleton-loader [theme]="{ height: '18px', width: '200px', 'margin-bottom': '0px' }"></ngx-skeleton-loader>
  </div>

  <div class="stacked-chart-report__body">
    <ngx-skeleton-loader [theme]="{ height: '200px', width: '500px' }"></ngx-skeleton-loader>
  </div>
</div>

<!-- /SKELETON-LOADER -->
